export const locale = {
    lang: 'en',
    data: {
        'CHANGE_PASSWORD_VIEW': {
            'TITLE': 'Change password',
            'OLD_PASSWORD': 'Current password',
            'NEW_PASSWORD': 'New password',
            'CONFIRM_NEW_PASSWORD': 'Retype new password',
            'ERROR_CODES':
                {
                    'POSER-REQ-014': 'The current password is not correct.\nPlease try again.',
                    'OTHER': 'Error occurs. Please try again.',
                },
            'SUGGESTION' : {
                'LENGTH': 'Password must contain 6 characters at least, except whitespace.',
                'SECURITY': 'To enhance account security, the password must contain at least 1 uppercase letter, 1 number, or 1 special character.'
            },
            'VALIDATION' : {
                'OLD_PASSWORD_REQUIRED': 'Current password is mandatory',
                'NEW_PASSWORD_REQUIRED': 'New password is mandatory',
                'NEW_PASSWORD_MINLENGTH': 'Password must contain 6 characters at least',
                'NEW_PASSWORD_NOT_SAME': 'The new password must differ from the old one',
                'NEW_PASSWORD_WHITESPACE': 'The new password must not contain whitespace',
                'CONFIRM_PASSWORD_REQUIRED': 'Retype new password is mandatory',
                'CONFIRM_PASSWORD_NOT_SAME': 'Retype password is mismatch',
            },
            'ACTION': {
                'SAVE_CHANGE':  'SAVE',
                'CLOSE':  'CLOSE',
            }
        },
        'CHANGE_PASSWORD_SUCCESS' : {
            'CLOSE': 'CLOSE',
            'MESSAGE': 'Your password has been changed successfully. Please re-login by the new password.',
            'TITLE': 'Changing password successfully!'
        }
    }
};
